import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Slice, Post, PostSlice } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {}

interface ActionData {
  slug: string
  post?: Post
}

const getSlice = (slice: PostSlice): PostSlice => {
  return slice ?? ({
    isFetching: false,
    isSuccess: false,
    isFailure: false,
    payload: undefined
  })
}

const slice = createSlice({
  name: 'blog/post',
  initialState,
  reducers: {
    request (state, action: PayloadAction<ActionData>) {
      const { slug } = action.payload
      const slice = getSlice(state[slug])
      slice.isFetching = true
      state[slug] = slice
    },

    success (state, action: PayloadAction<ActionData>) {
      const { slug, post } = action.payload
      const slice = getSlice(state[slug])
      slice.isFetching = false
      slice.isSuccess = true
      slice.isFailure = false
      slice.payload = post
      state[slug] = slice
    },

    failure (state, action: PayloadAction<ActionData>) {
      const { slug } = action.payload
      const slice = getSlice(state[slug])
      slice.isFetching = false
      slice.isSuccess = false
      slice.isFailure = true
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchPost (slug: string): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request({ slug }))
    try {
      const response = await magentoClient.getClient().blog.fetchPostList({
        filters: { url_key: slug }
      })
      const [post] = response.data?.posts?.items ?? []
      if (post) {
        dispatch(success({
          slug,
          post
        }))
      } else {
        dispatch(failure({ slug }))
      }
    } catch (e) {
      dispatch(failure({ slug }))
    }
  }
}
